import React from 'react';
import { useTranslation } from 'react-i18next';

function ImpactContent() {
    const { t } = useTranslation();
    return (
        <div> 
            <div className="mb-3  fw-semibold" style={{borderColor: "rgba(9, 26, 58, 1)" }}>★★★</div>

            <p className="text-uppercase text-muted mb-2">
                Tamil Nadu Warehousing Corporation
            </p>

            <h2 className="fw-bold display-6 mb-4">
                {t('impactTitle')}
            </h2>

            <p className="text-muted mb-4">
                {t('impactDesc')}
            </p>

            <ul className="impact-list mb-4">
                <li>{t('impactPoint1')}</li>
                <li>{t('impactPoint2')}</li>
                <li>{t('impactPoint3')}</li>
                <li>{t('impactPoint4')}</li>
            </ul>

            <button className="btn  learn-more-btn px-4" onClick={() => window.location.href = '/services'}>
                {t('learnMore')}
            </button>
        </div>
    );
}

export default ImpactContent;
